<template>
  <v-card id="mitigation-habitat-detail">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline" style="word-break: break-word;">
          {{ propMitigationHabitat.name }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen>
          <template #left>
            <Icon
            icon="mdi-pencil"
            iconColor="tertiary"
            :small="false"
            :tooltipText="$t('editItem', { item: $t('mitigationHabitat') })"
            :disabled="!isSustainabilityAdmin"
            @icon-clicked="$emit('edit', propMitigationHabitat)"
            elementId="mitigation-habitat-detail-edit"/>
          </template>
        </BaseDialogActions>
      </v-row>
    </v-card-title>
    <v-card-text class="pt-4">
      <DetailCard :title="$t('habitatDescription')" :fillHeight="false" elementClass="mb-4">
        <p v-if="hasText(propMitigationHabitat.description)" class="text-body-2 habitat-text mb-0">{{ propMitigationHabitat.description }}</p>
        <span v-else class="font-italic grey--text">{{ $t('noneSpecified') }}</span>
      </DetailCard>
      <DetailCard :title="$t('mitigationSteps')" :fillHeight="false">
        <p v-if="hasText(propMitigationHabitat.mitigationSteps)" class="text-body-2 habitat-text mb-0">{{ propMitigationHabitat.mitigationSteps }}</p>
        <span v-else class="font-italic grey--text">{{ $t('noneSpecified') }}</span>
      </DetailCard>
    </v-card-text>
  </v-card>
</template>

<script>
import { UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility'

export default {
  name: 'MitigationHabitatDetail',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    DetailCard: () => import('@/components/core/DetailCard.vue')
  },

  props: {
    propMitigationHabitat: {
      type: Object,
      required: true
    }
  },

  computed: {
    isSustainabilityAdmin () {
      return userAssignedClaim(UserClaims.SustainabilityAdmin)
    }
  },

  methods: {
    hasText (value) {
      return !!value?.trim()
    }
  }
}
</script>

<style scoped>
.habitat-text {
  white-space: pre-line;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
</style>
